import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle, } from 'react';
import { View } from 'react-native';
import TabBar from './tabBar/TabBar';
import { ShouldRender, traverseReactNode } from './utils';
import { useStyle } from './styles';
const TabPanel = () => {
    return null;
};
const Tabs = forwardRef((props, ref) => {
    var _a;
    const { kidtoken, scalable, type = 'primary', align = 'center', activeIndex, defaultIndex = 0, sliderAnimate = true, onTabBarPress, renderTabBarLeftSection, renderTabBarRightSection, customStyle = {}, showSlider, } = props;
    const { vars } = useStyle({
        kidtoken,
        scalable,
        customStyle,
    });
    const tabBarRef = useRef(null);
    const _index = activeIndex !== null && activeIndex !== void 0 ? activeIndex : defaultIndex;
    const [selectedIndex, setSelectedIndex] = useState(_index);
    useEffect(() => {
        tabBarRef.current.scrollToIndex(activeIndex);
        setSelectedIndex(activeIndex !== null && activeIndex !== void 0 ? activeIndex : defaultIndex);
    }, [activeIndex]);
    const pages = [];
    traverseReactNode(props.children, (child) => {
        if (!React.isValidElement(child)) {
            return;
        }
        const id = child.props.id;
        if (typeof id !== 'number' && typeof id !== 'string') {
            return;
        }
        pages.push(child);
    });
    //对齐方式与Tab数量的限制
    if (align === 'center' && pages.length > 5) {
        throw new Error('Tips:对齐设置center，只支持最多五个Tab');
    }
    // 获得tabBarData
    const tabBarData = (_a = pages.map((c) => {
        return {
            id: c.props.id,
            title: c.props.label,
            renderTabBarItem: c.props.renderTabBarItem && c.props.renderTabBarItem,
        };
    })) !== null && _a !== void 0 ? _a : [];
    /**
     * 外部通过ref访问
     */
    useImperativeHandle(ref, () => ({
        scrollTo: ({ index, id }) => {
            // 通过id找到index
            if (id || id === 0) {
                const targetIndex = tabBarData.findIndex((item) => item.id === id);
                index = targetIndex === -1 ? index : targetIndex;
            }
            tabBarRef.current.scrollToIndex(index);
            setSelectedIndex(index);
        },
    }));
    // 二级tab的对齐方式：left
    let _align = align;
    if (!align && type === 'secondary') {
        _align = 'left';
    }
    // 二级tab的默认不显示slider
    let _showSlider = showSlider !== null && showSlider !== void 0 ? showSlider : (type === 'secondary' ? false : true);
    const renderTabBarComponent = () => {
        return (React.createElement(TabBar, { kidtoken: kidtoken, scalable: scalable, customStyle: customStyle, ref: tabBarRef, routes: tabBarData, type: type, sliderAnimate: sliderAnimate, showSlider: _showSlider, onTabBarItemPress: ({ id, index }) => {
                onTabBarPress && onTabBarPress({ id, index });
                activeIndex === undefined && setSelectedIndex(index);
            }, defaultIndex: defaultIndex, activeIndex: activeIndex, renderLeftSection: renderTabBarLeftSection, renderRightSection: renderTabBarRightSection, 
            // 根据tabBar是否需要横向滚动来控制tabBar的scrollView的宽度
            tabBarMode: _align === 'left' ? 'scrollable' : 'fixed' }));
    };
    return (React.createElement(View, { testID: "TabsWrapper" },
        renderTabBarComponent(),
        React.createElement(View, { style: {
                width: vars.kid_tab_content_container_width,
            } }, pages === null || pages === void 0 ? void 0 : pages.map((page, index) => {
            if (page.props.children === undefined) {
                return null;
            }
            const active = index === selectedIndex;
            return (React.createElement(ShouldRender, { key: page.props.id, active: active, forceRender: page.props.forceRender, destroyOnClose: page.props.destroyOnClose },
                React.createElement(View, { style: {
                        display: active ? 'flex' : 'none',
                        flexGrow: 1,
                        width: vars.kid_tab_content_width,
                    } }, page.props.children)));
        }))));
});
export { Tabs, TabPanel };
